import { render, staticRenderFns } from "./view-tpl.vue?vue&type=template&id=5f0a9870&"
import script from "./view-tpl.vue?vue&type=script&lang=ts&"
export * from "./view-tpl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports